import React, { useCallback } from "react";

import { faWindowRestore } from "@awesome.me/kit-4c83d50d0d/icons/classic/regular";

import { transformUrlToCompanionMode } from "~/lib/desktopApi";
import { dispatchDesktopAnalyticsTrack } from "~/lib/desktopApi/analytics";
import { useRecordingState } from "~/localRecording/useRecordingState";
import Menu from "~/ui/menu";

export default function CompanionModeMenuItem({ url }: { url: string }) {
	const { isActive } = useRecordingState();

	const onCompanionModeClick = useCallback(() => {
		if (!window.electron || !window.electron.navigateCompanionMode) throw new Error("Companion mode not available.");
		if (url === null) throw new Error("Stream has no URL");

		dispatchDesktopAnalyticsTrack({ feature: "CompanionMode", event: "Open Companion From Stream" });

		window.electron.navigateCompanionMode(transformUrlToCompanionMode(url));
	}, [url]);

	// When a recording is in progress, don't allow opening a note in companion mode.
	return (
		<Menu.Item icon={faWindowRestore} onSelect={onCompanionModeClick} disabled={isActive}>
			Open in companion mode
		</Menu.Item>
	);
}
